import { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { SearchSectionStyled } from './SearchSection.styled'
import { PurchaseHistoryContext } from 'contexts/PurchaseHistoryContext'
import { DateRangePicker } from 'components/DateRangePicker/DatePicker'
import { IPurchaseHistoryRequest } from 'types/purchaseHistoryTypes'

export const SearchSection = () => {
  const { searchFilter, updateSearchFilter } = useContext(PurchaseHistoryContext)
  const [tempSearchFilter, setTempSearchFilter] = useState<IPurchaseHistoryRequest>(searchFilter)

  useEffect(() => {
    setTempSearchFilter((prev) => ({ ...prev, SortBy: searchFilter.SortBy }))
  }, [searchFilter.SortBy])
  return (
    <SearchSectionStyled>
      <Row className="history-search-section">
        <Col lg={6} sm={12} className="search-date-contain">
          <div className="search-date-main">
            <Row>
              <Col sm={12} md={3} xl={3} lg={12}>
                <label className="header-label">Choose a Date Range</label>
              </Col>
              <Col>
                <DateRangePicker
                  fromDate={new Date(tempSearchFilter?.FromDate)}
                  setFromDate={(date) => setTempSearchFilter({ ...tempSearchFilter, FromDate: date, Vin: null })}
                  toDate={new Date(tempSearchFilter?.ToDate)}
                  setToDate={(date) => setTempSearchFilter({ ...tempSearchFilter, ToDate: date, Vin: null })}
                  disabledMaxDate={false}
                />
              </Col>
              <Col sm={4} md={3} xl={3} lg={4}>
                <Button
                  type="submit"
                  className="btn-search"
                  variant="primary"
                  disabled={!tempSearchFilter?.FromDate || !tempSearchFilter?.ToDate}
                  onClick={() => {
                    updateSearchFilter({ ...tempSearchFilter, Vin: null, PageNumber: 0 })
                    setTempSearchFilter({ ...tempSearchFilter, Vin: null })
                  }}
                >
                  Search
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
        <Col lg={6} sm={12} className="search-vin-contain">
          <div className="search-vin-main">
            <Row>
              <Col sm={12} lg={12} xl={2} md={3}>
                <label className="header-label">Enter VIN</label>
              </Col>
              <Col sm={8} lg={8} xl={7} md={6} className="input-vin-contain">
                <Form.Control
                  type="input"
                  value={tempSearchFilter?.Vin ? tempSearchFilter?.Vin : ''}
                  placeholder="VIN #"
                  className="input-vin"
                  onChange={({ target }) => setTempSearchFilter({ ...tempSearchFilter, Vin: target.value })}
                />
              </Col>
              <Col sm={4} lg={4} xl={3} md={3} className="search-vin-btn">
                <Button
                  type="submit"
                  className="btn-search"
                  variant="secondary"
                  disabled={!tempSearchFilter?.Vin}
                  onClick={() => {
                    updateSearchFilter({ ...tempSearchFilter, PageNumber: 0 })
                  }}
                >
                  Search VIN
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </SearchSectionStyled>
  )
}

export default SearchSection
